module.exports = __webpack_public_path__ + "static/media/Impressum02.5f080060.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Impressum02.jpg
// module id = 403
// module chunks = 0